import styled from 'styled-components';
import { prsButtonTheme } from '../themes/prsButtonThemes';

export const PrsButton = styled.button`
  cursor: pointer;
  text-align: center;
  vertical-align: middle;
  outline-offset: 2px;
  user-select: none;
  padding-inline: ${prsButtonTheme.regular.padding};
  color: ${prsButtonTheme.regular.color};
  --tw-prose-links: ${prsButtonTheme.regular.color};
  height: ${prsButtonTheme.regular.height};
  font-family: ${prsButtonTheme.regular.fontFamily};
  font-size: ${prsButtonTheme.regular.fontSize};
  outline-color: ${prsButtonTheme.regular.baseContentColor};
  background-color: ${prsButtonTheme.regular.backgroundColor};
  background-size: auto,calc(${prsButtonTheme.regular.noiseSize}*100%);
  background-image: ${prsButtonTheme.regular.backgroundImage};
  border-width: ${prsButtonTheme.regular.borderWidth};
  border-style: solid;
  border-color: ${prsButtonTheme.regular.borderColor};
  text-shadow: 0 .5px oklch(100% 0 0/calc(${prsButtonTheme.regular.depth}*.15));
  touch-action: manipulation;
  box-shadow: 0 .5px 0 .5px oklch(100% 0 0/calc(${prsButtonTheme.regular.depth}*6%))inset,${prsButtonTheme.regular.buttonShadow};
  border-start-start-radius: ${prsButtonTheme.regular.borderRadius};
  border-start-end-radius: ${prsButtonTheme.regular.borderRadius};
  border-end-end-radius: ${prsButtonTheme.regular.borderRadius};
  border-end-start-radius: ${prsButtonTheme.regular.borderRadius};
  flex-wrap: nowrap;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  gap: 0.375rem;
  font-weight: 600;
  transition-property: color, background-color, border-color, box-shadow;
  transition-duration: 0.2s;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  display: inline-flex;
  :hover {
    background-color: ${prsButtonTheme.regular.hoverBackgroundColor};
    color: ${prsButtonTheme.regular.hoverColor};
  }
`

export const PrsDefaultButton = styled(PrsButton)`
  background-color: ${prsButtonTheme.default.backgroundColor};
  border-color: ${prsButtonTheme.default.borderColor};
  color: ${prsButtonTheme.default.color};
  :hover {
    color: ${prsButtonTheme.default.hoverColor};
  }
  :disabled {
    background-color: ${prsButtonTheme.default.disabledBackgroundColor};
    border-color: ${prsButtonTheme.default.disabledBorderColor};
    color: ${prsButtonTheme.default.disabledColor};
  }
`